import { FaExclamationTriangle, FaHome, FaEnvelope } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // or your routing solution
import './ErrorPage.css'; // Import your CSS file for styling

function ErrorPage() {
  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-icon">
          <FaExclamationTriangle />
        </div>
        <h1>404 - Page Not Found</h1>
        <p className="error-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="error-divider"></div>
        <p className="error-subtext">
          Here are some helpful links instead:
        </p>
        <div className="error-actions">
          <Link to="/" className="error-button">
            <FaHome /> Home
          </Link>
          <Link to="/contact" className="error-button">
            <FaEnvelope /> Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;